export default {
  正常碰蛋: '正常碰蛋',
  碰蛋出错: '碰蛋出错',
  我没中奖: '我没中奖',
  对方没中奖: '对方没中奖',
  今天没蛋了: '今天没蛋了',
  今天已经碰过: '今天已经碰过',
  对方没蛋了: '对方没蛋了',
  碰蛋消息: '碰蛋消息',
  碰蛋记录: '碰蛋记录',
  正常领蛋: '正常领蛋'
};